import * as React from 'react';
import { Button, Responsive } from 'semantic-ui-react';

import './styles.css';

export interface Props {
  toggleInput?: () => void;
}

export const MobileMenuToggle = (props: Props) => {
  return (
    <Responsive {...Responsive.onlyMobile} className="inline-button-container">
      <Button
        icon="bars"
        className="mobile-menu-toggle mobile-button"
        onClick={props.toggleInput}
      />
    </Responsive>
  );
};


// WEBPACK FOOTER //
// ./src/components/mobile-menu-toggle/component.tsx